<template>
<!--    <support-popup></support-popup>-->
    <footer>
        <div class="container">
            <div class="row">
                <div class="col-md-4 col-sm-6">
                    <nav class="footer-nav">
                        <ul>
                            <li><a :href="$store.state.hrefPrefix + '/'">{{ $t('home') }}</a></li>
                            <li v-for="category in categories"><a
                                :href="$store.state.hrefPrefix + '/category/' + category.slug">
                                {{ category.category_languages[0].pivot.name }}</a></li>
                            <li><a :href="$store.state.hrefPrefix + '/privacy'">{{ $t('Privacy') }}</a></li>
                            <li v-if="$store.state.language.code === 'tr'"><a :href="$store.state.hrefPrefix + '/masthead'">Künye</a></li>
                            <!--                            <li><a href="#">Contact us</a></li>-->
                        </ul>
                    </nav>
                </div>
                <div class="col-md-4 col-sm-6">
                    <div class="footer-Newsletter-input" v-if="$store.state.language.code !== 'tr'">
                        <span>{{ $t('subscribe_to_our_newsletter') }}</span>
                        <form :action="$store.state.hrefPrefix + '/subscribe'" method="post" ref="subscribe"
                              @submit.prevent="">
                            <input type="hidden" name="_token" :value="csrf">
                            <div class="Newsletter-input">
                                <input type="text" :placeholder="$t('your_email_address')" name="email"/>
                                <button class="g-recaptcha"
                                        data-sitekey="6Ld3Xv8mAAAAAJSdwXb6BysaOps8-vQJMk9W_ej5"
                                        data-callback="submitSubscribe">
                                    {{ $t('cap_subscribe') }}
                                </button>
                            </div>
                        </form>

                    </div>
                    <a href="https://donate.thecradle.co" target="_blank" v-if="$store.state.language.code !== 'tr'" class="footer-Support">{{
                            $t('support_us')
                        }}<i><img src="/assets/images/heart-icon.svg?v=2"
                                  alt=""></i>
                    </a>
                </div>
                <div class="col-md-4 col-sm-6">
                    <div class="footer-right">
                        <div class="footer-logo">

                            <a v-if="$store.state.language.code === 'ar'" :href="$store.state.hrefPrefix + '/'"><img
                                src="/assets/images/thecradle-ar-logo.svg?v=2" alt=""/></a>
                            <a v-else-if="$store.state.language.code === 'en'"
                               :href="$store.state.hrefPrefix + '/'"><img
                                src="/assets/images/the-cradle-logo.svg?v=2" alt=""/></a>
                            <a v-else-if="$store.state.language.code === 'tr'"
                               :href="$store.state.hrefPrefix + '/'"><img
                                src="/assets/images/thecradle-tr-logo.svg?v=2" alt=""/></a>
                        </div>
                        <ul class="footer-social-links">
                            <li v-if="$store.state.language.code === 'ar'"><a
                                href="https://www.facebook.com/thecradlearabi/" target="_blank">
                                <img src="/assets/images/footer-fb.svg?v=2"
                                     onmouseover="this.src='/assets/images/fb-hover.svg?v=2'"
                                     onmouseout="this.src='/assets/images/footer-fb.svg?v=2'" alt=""/></a></li>
                            <li v-else-if="$store.state.language.code === 'tr'"><a
                                href="https://www.facebook.com/profile.php?id=61573869121346" target="_blank">
                                <img src="/assets/images/footer-fb.svg?v=2"
                                     onmouseover="this.src='/assets/images/fb-hover.svg?v=2'"
                                     onmouseout="this.src='/assets/images/footer-fb.svg?v=2'" alt=""/></a></li>
<!--                            <li v-else><a href="https://www.facebook.com/thecradlemedia/" target="_blank">-->
<!--                                <img src="/assets/images/footer-fb.svg?v=2"-->
<!--                                     onmouseover="this.src='/assets/images/fb-hover.svg?v=2'"-->
<!--                                     onmouseout="this.src='/assets/images/footer-fb.svg?v=2'" alt=""/></a></li>-->

                            <!-- PATREON -->
                            <li v-if="$store.state.language.code === 'en'">
                                <a href="https://www.patreon.com/thecradlemedia" target="_blank">
                                    <img src="/assets/images/footer-patreon.svg?v=2"
                                         onmouseover="this.src='/assets/images/footer-patreon-hover.svg?v=2'"
                                         onmouseout="this.src='/assets/images/footer-patreon.svg?v=2'"
                                         alt="Patreon"/>
                                </a>
                            </li>

                            <!-- INSTAGRAM -->
                            <li v-if="$store.state.language.code === 'ar'">
                                <a href="https://www.instagram.com/thecradlearabi/" target="_blank">
                                    <img src="/assets/images/footer-insta.svg?v=2"
                                         onmouseover="this.src='/assets/images/insta-hover.svg?v=2'"
                                         onmouseout="this.src='/assets/images/footer-insta.svg?v=2'"
                                         alt="Instagram"/>
                                </a>
                            </li>
                            <li v-else-if="$store.state.language.code === 'tr'">
                                <a href="https://www.instagram.com/cradleturkiye" target="_blank">
                                    <img src="/assets/images/footer-insta.svg?v=2"
                                         onmouseover="this.src='/assets/images/insta-hover.svg?v=2'"
                                         onmouseout="this.src='/assets/images/footer-insta.svg?v=2'"
                                         alt="Instagram"/>
                                </a>
                            </li>
                            <li v-else>
                                <a href="https://instagram.com/tcmedianews" target="_blank">
                                    <img src="/assets/images/footer-insta.svg?v=2"
                                         onmouseover="this.src='/assets/images/insta-hover.svg?v=2'"
                                         onmouseout="this.src='/assets/images/footer-insta.svg?v=2'"
                                         alt="Instagram"/>
                                </a>
                            </li>

                            <!-- X -->
                            <li v-if="$store.state.language.code === 'ar'">
                                <a href="https://twitter.com/TheCradleArabi" target="_blank">
                                    <img src="/assets/images/footer-twitter.svg?v=2" style="width: 20px"
                                         onmouseover="this.src='/assets/images/footer-twitter-hover.svg?v=2'"
                                         onmouseout="this.src='/assets/images/footer-twitter.svg?v=2'"
                                         alt="X"/>
                                </a>
                            </li>
                            <li v-else-if="$store.state.language.code === 'tr'">
                                <a href="https://x.com/cradleturkiye" target="_blank">
                                    <img src="/assets/images/footer-twitter.svg?v=2" style="width: 20px"
                                         onmouseover="this.src='/assets/images/footer-twitter-hover.svg?v=2'"
                                         onmouseout="this.src='/assets/images/footer-twitter.svg?v=2'"
                                         alt="X"/>
                                </a>
                            </li>
                            <li v-else>
                                <a href="https://x.com/thecradlemedia" target="_blank">
                                    <img src="/assets/images/footer-twitter.svg?v=2" style="width: 20px"
                                         onmouseover="this.src='/assets/images/footer-twitter-hover.svg?v=2'"
                                         onmouseout="this.src='/assets/images/footer-twitter.svg?v=2'"
                                         alt="X"/>
                                </a>
                            </li>


                            <li v-if="$store.state.language.code === 'ar'">
                                <a href=" https://t.me/thecradlearabi" target="_blank">
                                    <img src="/assets/images/links-footer.svg?v=2"
                                         onmouseover="this.src='/assets/images/links-hover.svg?v=2'"
                                         onmouseout="this.src='/assets/images/links-footer.svg?v=2'" alt=""/>
                                </a>
                            </li>
                            <li v-else-if="$store.state.language.code === 'tr'">
                                <a href="https://t.me/cradleturkiye" target="_blank">
                                    <img src="/assets/images/links-footer.svg?v=2"
                                         onmouseover="this.src='/assets/images/links-hover.svg?v=2'"
                                         onmouseout="this.src='/assets/images/links-footer.svg?v=2'" alt=""/>
                                </a>
                            </li>
                            <li v-else>
                                <a href="https://t.me/thecradlemedia" target="_blank">
                                    <img src="/assets/images/links-footer.svg?v=2"
                                         onmouseover="this.src='/assets/images/links-hover.svg?v=2'"
                                         onmouseout="this.src='/assets/images/links-footer.svg?v=2'" alt=""/>
                                </a>
                            </li>

                            <!-- YOUTUBE -->
                            <li v-if="$store.state.language.code === 'en'">
                                <a href="https://www.youtube.com/@thecradlemedia" target="_blank">
                                    <img src="/assets/images/footer-youtube.svg?v=2"
                                         onmouseover="this.src='/assets/images/footer-youtube-hover.svg?v=2'"
                                         onmouseout="this.src='/assets/images/footer-youtube.svg?v=2'"
                                         alt="YouTube"/>
                                </a>
                            </li>


                        </ul>
                        <span class="footer-email"><a href="mailto:contact@thecradle.co">contact@thecradle.co</a></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="sub_footer" style="background-color: #54585E">
            <span>{{ $t('copyright') }}</span>
            <ul>
                <li><a :href="$store.state.hrefPrefix + '/terms'">{{ $t('Terms') }}</a></li>
                <li><a :href="$store.state.hrefPrefix + '/privacy'">{{ $t('Privacy') }}</a></li>
                <li v-if="$store.state.language.code === 'en'"><a href="/articles/hello-to-the-cradle">{{
                        $t('About')
                    }}</a></li>
                <li v-if="$store.state.language.code === 'ar'"><a
                    :href="$store.state.hrefPrefix + '/about'">{{ $t('About') }}</a></li>
            </ul>
        </div>
    </footer>
</template>

<script>
import SupportPopup from "@/parts/home/TopBar/SupportPopup.vue";

export default {
    name: "FootBar",
    components: {SupportPopup},
    data() {
        return {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
    },
    props: {
        activeTab: {
            type: String,
            default: 'Home'
        },
        categories: {
            type: Array,
            default: []
        },
    },
    methods: {
        // openSupportPopup(){
        //     document.getElementById('support-popup').style.visibility = 'visible';
        // },
        submitSubscribe(response) {
            console.log(response)
            const form = this.$refs.subscribe;
            form.submit();
        }
    },
    mounted() {
        window.submitSubscribe = this.submitSubscribe;
    }
}
</script>

<style>
@media (max-width: 960px) {
    footer .footer-Newsletter-input .Newsletter-input button {
        margin: 0 auto;
        width: 100%;
    }
}

</style>
